module.exports = __webpack_public_path__ + "img/icon_sub_04.b44739e3.jpg";